// extracted by mini-css-extract-plugin
export default {"mainContainer":"productCataloguePage_mainContainer__Rp0BE","innerContainer":"productCataloguePage_innerContainer__6UxPZ"};